/** Convert ISO date string to date input value (YYYY-MM-DD) */
export const dateToInput = (v: string | null): string =>
  v ? v.substring(0, 10) : '';

/** Convert date input value to ISO string or null */
export const inputToDate = (v: string): string | null =>
  v ? v + 'T00:00:00Z' : null;

/** Format a number for display */
export const fmt = (v: number | null | undefined): string =>
  v == null || v === 0
    ? '0'
    : v.toLocaleString('en-US', { maximumFractionDigits: 2 });

/**
 * Frontend preview of auto-calculations per BR-008.
 * Backend does the authoritative calculation on save.
 */
export function calcDetailRow(
  row: { fp621_14: number; fp621_15: number; fp621_17: number; fp621_18: number },
  mtsRate: number,
  nwRate: number,
  gwIncrement: number,
  isPCS: boolean,
): { fp621_15: number; fp621_16: number; fp621_17: number } {
  let nw = row.fp621_15;
  let mts = row.fp621_17;

  if (!isPCS) {
    // MTS calc: only if current MTS is 0
    if (mts === 0 && mtsRate > 0) {
      mts = Math.round(mtsRate * row.fp621_14);
    }
  }

  // N.W. calc: only if current N.W. is 0
  if (nw === 0 && nwRate > 0) {
    nw = nwRate * (row.fp621_14 + row.fp621_18);
  }

  // G.W. = INT(N.W.) + increment
  const gw = Math.floor(nw) + gwIncrement;

  return { fp621_15: nw, fp621_16: gw, fp621_17: mts };
}
